function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import useIntlMemo from '@/hooks/useIntlMemo';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { UserLevels } from '@/types/server';
import { Button, ButtonGroup, FormControl, FormErrorMessage, FormHelperText, FormLabel, Heading, Icon, Input, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Select, Text, Textarea, useDisclosure } from '@chakra-ui/react';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import useChannelStore from '@/stores/ChannelStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router';
import { createCustomCommand, getCustomCommand, getCustomCommands, getDefaultCommands, updateCustomCommand } from '@/actions/CommandActions';
import useCustomCommandStore from '@/stores/CustomCommandStore';
import { Helmet } from 'react-helmet';
import useDefaultCommandStore from '@/stores/DefaultCommandStore';
import useBackButton from '@/hooks/useBackButton';
import BackButton from '../BackButton';
import useDebouncedCallbackOnChange from '@/hooks/useDebouncedCallbackOnChange';
var DEFAULT_VALUES = {
    name: '',
    userLevel: UserLevels.EVERYONE,
    message: '',
    coolDown: 5,
    alias: ''
};
var MIN_COOLDOWN = 1;
var MAX_COOLDOWN = 300;
function useCustomCommandFormSchema(channelId, currentCommandName) {
    var customCommands = useCustomCommandStore(function(state) {
        return state.getCommandsForChannel(channelId);
    });
    var defaultCommands = useDefaultCommandStore(function(state) {
        return state.getCommandsForChannel(channelId);
    });
    useEffect(function() {
        if (channelId == null) {
            return;
        }
        if (customCommands == null) {
            getCustomCommands(channelId);
        }
        if (defaultCommands == null) {
            getDefaultCommands(channelId);
        }
    }, [
        channelId,
        customCommands,
        defaultCommands
    ]);
    return useIntlMemo(function(intl) {
        var filteredCustomCommands = customCommands === null || customCommands === void 0 ? void 0 : customCommands.filter(function(command) {
            return command.name !== currentCommandName;
        }).map(function(command) {
            return command.name;
        });
        var filteredDefaultCommands = defaultCommands === null || defaultCommands === void 0 ? void 0 : defaultCommands.map(function(command) {
            return command.name;
        });
        return Yup.object().shape({
            name: Yup.string().required(intl.formatMessage({
                id: "Gvxoji",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Name is required"
                    }
                ]
            })).min(1, intl.formatMessage({
                id: "sC8N/O",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Name must be at least 1 character long"
                    }
                ]
            })).max(50, intl.formatMessage({
                id: "N2/BvL",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Name must be at most 50 characters long"
                    }
                ]
            })),
            userLevel: Yup.string().required(intl.formatMessage({
                id: "J4OhND",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Userlevel is required"
                    }
                ]
            })),
            message: Yup.string().required(intl.formatMessage({
                id: "W9eAga",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Response is required"
                    }
                ]
            })).min(1, intl.formatMessage({
                id: "S+2fit",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Response must be at least 1 character long"
                    }
                ]
            })).max(500, intl.formatMessage({
                id: "woupAM",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Response must be at most 500 characters long"
                    }
                ]
            })).when('alias', {
                is: function(alias) {
                    return alias != null && alias.length > 0;
                },
                then: function(schema) {
                    return schema.notRequired();
                }
            }),
            coolDown: Yup.number().required(intl.formatMessage({
                id: "JVJy/u",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown is required"
                    }
                ]
            })).min(MIN_COOLDOWN, intl.formatMessage({
                id: "DmRtwY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown must be at least 1 second long"
                    }
                ]
            })).max(MAX_COOLDOWN, intl.formatMessage({
                id: "+rzoMT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown must be at most 300 seconds long"
                    }
                ]
            })),
            alias: Yup.string().min(1, intl.formatMessage({
                id: "9PghMc",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Alias must be at least 1 character long"
                    }
                ]
            })).max(50, intl.formatMessage({
                id: "A6SdPi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Alias must be at most 50 characters long"
                    }
                ]
            })).oneOf(filteredCustomCommands != null && filteredDefaultCommands != null ? _to_consumable_array(filteredCustomCommands).concat(_to_consumable_array(filteredDefaultCommands)) : [], intl.formatMessage({
                id: "i5Oiu8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Alias must be set to an existing command"
                    }
                ]
            })),
            count: Yup.number()
        });
    }, [
        customCommands,
        defaultCommands
    ]);
}
export default function CommandsCustom(param) {
    var formik = param.formik, title = param.title, submitText = param.submitText, error = param.error;
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var advanced = useDisclosure();
    var back = useBackButton(WebRoutes.COMMANDS_CUSTOM).back;
    var showCount = // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    formik.values.message != null && formik.values.message.includes('$(count)') || formik.values.count != null && formik.values.count > 0;
    var _formik_values_name, _formik_values_message, _channel_userLevels, _formik_values_coolDown, _formik_values_count, _formik_values_alias;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            maxWidth: 'container.md'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: title
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: WebRoutes.COMMANDS_CUSTOM,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "TY8Ho1",
                    defaultMessage: "Commands"
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: title
            }),
            /*#__PURE__*/ _jsxs(FormControl, {
                id: "name",
                isInvalid: formik.errors.name != null && formik.touched.name,
                children: [
                    /*#__PURE__*/ _jsx(FormLabel, {
                        htmlFor: "name",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "HAlOn1",
                            defaultMessage: "Name"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        autoFocus: true,
                        "data-1p-ignore": true,
                        value: (_formik_values_name = formik.values.name) !== null && _formik_values_name !== void 0 ? _formik_values_name : '',
                        onBlur: formik.handleBlur,
                        onChange: formik.handleChange,
                        placeholder: "!discord",
                        backgroundColor: "backgroundPrimary",
                        _focus: {
                            borderColor: 'borderTertiary',
                            backgroundColor: 'backgroundPrimary'
                        }
                    }),
                    /*#__PURE__*/ _jsx(FormErrorMessage, {
                        children: formik.errors.name
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(FormControl, {
                id: "message",
                isInvalid: formik.errors.message != null && formik.touched.message,
                children: [
                    /*#__PURE__*/ _jsx(FormLabel, {
                        htmlFor: "message",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "MgdnPi",
                            defaultMessage: "Response"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Textarea, {
                        value: (_formik_values_message = formik.values.message) !== null && _formik_values_message !== void 0 ? _formik_values_message : '',
                        onBlur: formik.handleBlur,
                        onChange: formik.handleChange,
                        placeholder: intl.formatMessage({
                            id: "TqWyrP",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Join my discord! "
                                },
                                {
                                    type: 1,
                                    value: "discordUrl"
                                }
                            ]
                        }, {
                            discordUrl: ExternalUrls.DISCORD
                        }),
                        backgroundColor: "backgroundPrimary",
                        _focus: {
                            borderColor: 'borderTertiary',
                            backgroundColor: 'backgroundPrimary'
                        }
                    }),
                    /*#__PURE__*/ _jsx(FormErrorMessage, {
                        children: formik.errors.message
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(FormControl, {
                id: "userLevel",
                isInvalid: formik.errors.userLevel != null && formik.touched.userLevel,
                children: [
                    /*#__PURE__*/ _jsx(FormLabel, {
                        htmlFor: "userLevel",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "yoVadE",
                            defaultMessage: "Required User-Level"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        onBlur: formik.handleBlur,
                        value: formik.values.userLevel,
                        onChange: formik.handleChange,
                        children: Object.entries((_channel_userLevels = channel === null || channel === void 0 ? void 0 : channel.userLevels) !== null && _channel_userLevels !== void 0 ? _channel_userLevels : {}).map(function(param) {
                            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                            return /*#__PURE__*/ _jsx("option", {
                                value: key,
                                children: value
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ _jsx(FormErrorMessage, {
                        children: formik.errors.userLevel
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                width: "fit-content",
                leftIcon: /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: advanced.isOpen ? faChevronUp : faChevronDown
                }),
                size: "sm",
                justifyContent: "left",
                variant: "link",
                onMouseDown: function() {
                    return advanced.onToggle();
                },
                children: advanced.isOpen ? /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "jL05H+",
                    defaultMessage: "Hide Advanced Settings"
                }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "qgD3rD",
                    defaultMessage: "Show Advanced Settings"
                })
            }),
            advanced.isOpen ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(FormControl, {
                        id: "coolDown",
                        isInvalid: formik.errors.coolDown != null && formik.touched.coolDown,
                        children: [
                            /*#__PURE__*/ _jsx(FormLabel, {
                                htmlFor: "coolDown",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "1PlglC",
                                    defaultMessage: "Cooldown (seconds)"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(NumberInput, {
                                max: MAX_COOLDOWN,
                                min: MIN_COOLDOWN,
                                value: (_formik_values_coolDown = formik.values.coolDown) !== null && _formik_values_coolDown !== void 0 ? _formik_values_coolDown : '',
                                onChange: function(_, newValue) {
                                    return formik.setFieldValue('coolDown', isNaN(newValue) ? 0 : newValue);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(NumberInputField, {
                                        onBlur: formik.handleBlur,
                                        placeholder: "5",
                                        backgroundColor: "backgroundPrimary",
                                        _focus: {
                                            borderColor: 'borderTertiary',
                                            backgroundColor: 'backgroundPrimary'
                                        }
                                    }),
                                    /*#__PURE__*/ _jsxs(NumberInputStepper, {
                                        children: [
                                            /*#__PURE__*/ _jsx(NumberIncrementStepper, {}),
                                            /*#__PURE__*/ _jsx(NumberDecrementStepper, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(FormErrorMessage, {
                                children: formik.errors.coolDown
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(FormControl, {
                        display: showCount ? 'block' : 'none',
                        id: "count",
                        isInvalid: formik.errors.count != null && formik.touched.count,
                        children: [
                            /*#__PURE__*/ _jsx(FormLabel, {
                                htmlFor: "count",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Aujn2T",
                                    defaultMessage: "Count"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(NumberInput, {
                                value: (_formik_values_count = formik.values.count) !== null && _formik_values_count !== void 0 ? _formik_values_count : '',
                                onChange: function(_, newValue) {
                                    return formik.setFieldValue('count', isNaN(newValue) ? 0 : newValue);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(NumberInputField, {
                                        onBlur: formik.handleBlur,
                                        placeholder: "5",
                                        backgroundColor: "backgroundPrimary",
                                        _focus: {
                                            borderColor: 'borderTertiary',
                                            backgroundColor: 'backgroundPrimary'
                                        }
                                    }),
                                    /*#__PURE__*/ _jsxs(NumberInputStepper, {
                                        children: [
                                            /*#__PURE__*/ _jsx(NumberIncrementStepper, {}),
                                            /*#__PURE__*/ _jsx(NumberDecrementStepper, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(FormHelperText, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Af6uEV",
                                    defaultMessage: "The number of times this command has been used."
                                })
                            }),
                            /*#__PURE__*/ _jsx(FormErrorMessage, {
                                children: formik.errors.count
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(FormControl, {
                        id: "alias",
                        isInvalid: formik.errors.alias != null && formik.touched.alias,
                        children: [
                            /*#__PURE__*/ _jsx(FormLabel, {
                                htmlFor: "alias",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wVPpM1",
                                    defaultMessage: "Alias Of"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                value: (_formik_values_alias = formik.values.alias) !== null && _formik_values_alias !== void 0 ? _formik_values_alias : '',
                                onBlur: formik.handleBlur,
                                onChange: formik.handleChange,
                                placeholder: "!commands",
                                backgroundColor: "backgroundPrimary",
                                _focus: {
                                    borderColor: 'borderTertiary',
                                    backgroundColor: 'backgroundPrimary'
                                }
                            }),
                            /*#__PURE__*/ _jsx(FormErrorMessage, {
                                children: formik.errors.alias
                            }),
                            /*#__PURE__*/ _jsx(FormHelperText, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "gIUWqo",
                                    defaultMessage: 'A command that "{name}" is an alias of. When set, calling "{name}" triggers the specified command to run in its place.',
                                    values: {
                                        name: formik.values.name
                                    }
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsxs(ButtonGroup, {
                size: "sm",
                spacing: 4,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        onClick: back,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "47FYwb",
                            defaultMessage: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "cta",
                        onClick: function() {
                            return formik.handleSubmit();
                        },
                        isLoading: formik.isSubmitting,
                        isDisabled: !formik.isValid || !formik.dirty,
                        children: submitText
                    })
                ]
            }),
            error != null ? /*#__PURE__*/ _jsx(Text, {
                textAlign: "right",
                color: "negative",
                children: error
            }) : null
        ]
    });
}
export function CommandsCustomCreate() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var intl = useIntl();
    var CustomCommandFormSchema = useCustomCommandFormSchema(channel === null || channel === void 0 ? void 0 : channel._id, null);
    var formik = useFormik({
        initialValues: DEFAULT_VALUES,
        validationSchema: CustomCommandFormSchema,
        validateOnChange: false,
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting;
            if (channel == null) {
                return;
            }
            setSubmitting(true);
            createCustomCommand(channel._id, values).then(function(newCommand) {
                var url = new URL(WebRoutes.COMMANDS_CUSTOM, window.location.origin);
                url.searchParams.set('search', newCommand.name);
                navigate(url.pathname + url.search);
            }).catch(function(error) {
                if (_instanceof(error, Error)) {
                    setError(error.message);
                } else {
                    setError('An unknown error occurred.');
                }
                setSubmitting(false);
            });
        }
    });
    useDebouncedCallbackOnChange(formik, formik.validateForm);
    return /*#__PURE__*/ _jsx(CommandsCustom, {
        formik: formik,
        error: error,
        title: intl.formatMessage({
            id: "2xN+AO",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Command"
                }
            ]
        }),
        submitText: intl.formatMessage({
            id: "VzzYJk",
            defaultMessage: [
                {
                    type: 0,
                    value: "Create"
                }
            ]
        })
    });
}
export function CommandsCustomEdit() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var navigate = useNavigate();
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var commandId = useParams().commandId;
    var back = useBackButton(WebRoutes.COMMANDS_CUSTOM).back;
    var cachedCommand = useCustomCommandStore(function(state) {
        return channel != null && commandId != null ? state.getCommand(channel._id, commandId) : null;
    });
    var CustomCommandFormSchema = useCustomCommandFormSchema(channel === null || channel === void 0 ? void 0 : channel._id, cachedCommand === null || cachedCommand === void 0 ? void 0 : cachedCommand.name);
    var formik = useFormik({
        initialValues: cachedCommand !== null && cachedCommand !== void 0 ? cachedCommand : DEFAULT_VALUES,
        validationSchema: CustomCommandFormSchema,
        validateOnChange: false,
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting;
            if (channel == null || commandId == null) {
                return;
            }
            setSubmitting(true);
            updateCustomCommand(channel._id, _object_spread({
                _id: commandId
            }, values)).then(function() {
                return back();
            }).catch(function(error) {
                if (_instanceof(error, Error)) {
                    setError(error.message);
                } else {
                    setError('An unknown error occurred.');
                }
                setSubmitting(false);
            });
        }
    });
    useDebouncedCallbackOnChange(formik, formik.validateForm);
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        if (commandId == null) {
            navigate(WebRoutes.COMMANDS_CUSTOM);
            return;
        }
        getCustomCommand(channel._id, commandId).then(function(command) {
            return formik.resetForm({
                values: command
            });
        }).catch(function() {
            return navigate(WebRoutes.COMMANDS_CUSTOM);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commandId,
        channel,
        navigate
    ]);
    return /*#__PURE__*/ _jsx(CommandsCustom, {
        formik: formik,
        error: error,
        title: intl.formatMessage({
            id: "dGRQmn",
            defaultMessage: [
                {
                    type: 0,
                    value: "Edit Command"
                }
            ]
        }),
        submitText: intl.formatMessage({
            id: "BWpuKl",
            defaultMessage: [
                {
                    type: 0,
                    value: "Update"
                }
            ]
        })
    });
}
